/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_DescriptionInputs */



/**
* | output |
* | --- |
* | "Full oneAI release history — breaking changes, features, and fixes." |
*
* @param {Whats_New_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const whats_new_description = /** @type {((inputs?: Whats_New_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollständiger oneAI Release-Verlauf — Breaking Changes, Features und Fixes.")
	return /** @type {LocalizedString} */ ("Full oneAI release history — breaking changes, features, and fixes.")
});